export enum CRMStatsDateFilter {
CurrentMonth,
CurrentQuarter,
CurrentYear,
Custom,
}
